import React from 'react'
import {
  Label,
  ListFieldProps,
  FieldChangeCallback,
} from '@sitecore-jss/sitecore-jss-react-forms'
import { ValueFormField } from '@sitecore-jss/sitecore-jss-forms'

const checkBoxListField: React.FunctionComponent<ListFieldProps> = (props) => {
  const {
    field,
    field: {
      model: { items },
    },
    value,
    onChange,
    errors,
    tracker,
  } = props

  const FieldValidationErrors = props.fieldValidationErrorsComponent

  const checkBoxtds = (Checkboxitems: any) => {
    return Checkboxitems.map((item: any, index: number) => (
      <div
        className={`checkBoxListTableCell sitecore-jss-form__control--checkboxFlex ${
          field.model.name === 'Lists' ? 'checkBoxListSubscribeForm' : ''
        }`}
        key={index}
      >
        <label className="sitecore-jss-form__control--checkboxLabel">
          <input
            type="checkbox"
            className={
              value.some((v) => v === item.value)
                ? 'sitecore-jss-form__control--checkbox checked'
                : 'sitecore-jss-form__control--checkbox'
            }
            id={field.valueField.id + index}
            name={field.valueField.name}
            value={item.value}
            checked={value.some((v) => v === item.value)}
            onChange={(e) =>
              handleOnChange(
                field,
                value,
                e.target.value,
                e.target.checked,
                onChange
              )
            }
            onFocus={() => tracker.onFocusField(field, value)}
            onBlur={() => tracker.onBlurField(field, value, errors)}
          />

          {item.text}
        </label>
      </div>
    ))
  }

  const generateCheckBoxes = (
    Checkboxitems: Array<any>,
    columnCount: number
  ): any => {
    let chkbxTds = checkBoxtds(Checkboxitems)
    let rows: JSX.Element[] = []

    while (chkbxTds.length > 0) {
      let length = columnCount > chkbxTds.length ? chkbxTds.length : columnCount
      rows.push(
        <div
          style={{ display: 'table-row' }}
          className={
            field.model.name === 'Lists' ? 'emailalert_checboxList' : ''
          }
        >
          {chkbxTds.splice(0, length)}
        </div>
      )
    }
    return rows
  }

  let columnNumber = window?.innerWidth <= 750 ? '1' : '2'

  return (
    <div style={{ display: 'table', width: '100%' }}>
      <div
        style={{
          marginBottom: '20px',
          marginTop: '20px',
          paddingRight: '30px',
        }}
      >
        <Label {...props} />
      </div>

      {generateCheckBoxes(items, +columnNumber)}

      <div>
        {FieldValidationErrors && <FieldValidationErrors {...props} />}
      </div>
    </div>
  )
}

/**
 * @param {ValueFormField} field
 * @param {string[]} originalFieldValue
 * @param {string} changedElement
 * @param {boolean} checked
 * @param {FieldChangeCallback} callback
 */
function handleOnChange(
  field: ValueFormField,
  originalFieldValue: string[],
  changedElement: string,
  checked: boolean,
  callback: FieldChangeCallback
) {
  // we can have multiple selected values. So we need to push ALL the selected
  // values back up to the root form. This is done using an array, which the form
  // serializer knows how to expand into multiple values on post

  let value = originalFieldValue

  if (checked) {
    value.push(changedElement)
  } else {
    value = value.filter((v) => v !== changedElement)
  }

  callback(field.valueField.name, value, true, [])
}

export default checkBoxListField
